import apiClient from "./apiClient";

const BASE = "/performance/evaluations";

// Every write returns the full EvaluationDetails (with live scores).
export const performanceService = {
  // ---------------- Employee ----------------

  getMine: () => apiClient.get(`${BASE}/my`),

  // Replaces the whole self-assessment draft.
  saveSelfAssessment: (id, responses) =>
    apiClient.put(`${BASE}/${id}/self-assessment`, { responses }),

  submitSelfAssessment: (id) =>
    apiClient.post(`${BASE}/${id}/self-assessment/submit`),

  // response: "ACCEPT" (-> COMPLETED) | "CONTEST" (-> CONTESTED, HR decides); comment required.
  acknowledge: (id, { response, comment }) =>
    apiClient.post(`${BASE}/${id}/acknowledge`, { response, comment }),

  // ---------------- Evaluator ----------------

  getToEvaluate: ({ includeDone = false } = {}) =>
    apiClient.get(`${BASE}/to-evaluate`, { params: { includeDone } }),

  // Replaces the whole ratings draft; the response carries live scores.
  saveResponses: (id, responses) =>
    apiClient.put(`${BASE}/${id}/responses`, { responses }),

  submit: (id) => apiClient.post(`${BASE}/${id}/submit`),

  // ---------------- Shared ----------------

  getById: (id) => apiClient.get(`${BASE}/${id}`),
};
